import SvgPanZoom from '../../../node_modules/svg-pan-zoom/dist/svg-pan-zoom.min';

const classes = {
    elementNode: 'imwa',
    accordionNode: 'accordion',
    mapNode: 'imwa__map',
    mapAnimated: 'imwa__map--is-animated',
    mapImageNode: 'imwa__map__image',
    mapPinNode: 'imwa__map__pin',
    mapGroupPinGroup: 'imwa__map__image-groups',
    mapZoomInButton: 'imwa__map-zoom-in',
    mapZoomOutButton: 'imwa__map-zoom-out',
    filterOptionsNode: 'imwa__filter-options',
    selectNode: 'imwa__filter-options__select',
};

document.addEventListener('alpine:init', () => {
    Alpine.data('interactiveMapWithAccordion', () => ({
        map: null,
        zoom: 2,
        activeAccordionItemId: null,
        selectedRegion: null,
        selectedCountry: null,
        selectedCategory: null,
        pinPositions: [],
        groupPins: [],

        init() {
            const mapImage = this.$root.querySelector(`.${classes.mapImageNode}`);
            const isMobile = window.innerWidth < 768;
            this.map = new SvgPanZoom(mapImage, {
                zoomEnabled: true,
                zoomScaleSensitivity: 0.5,
                controlIconsEnabled: false,
                dblClickZoomEnabled: false,
                mouseWheelZoomEnabled: false,
                fit: true,
                zoom: 2,
                center: 1,
                minZoom: 1,
                maxZoom: isMobile ? 30 : 20,
            });

            if (isMobile) {
                // on mobile show only part of the map
                this.map.zoomIn();
                this.map.pan({
                    x: -20,
                    y: 0,
                });
            }
            this.zoom = this.map.getZoom();

            // support configuration via url parameters
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            this.selectedRegion = urlParams.get('map-region') || null;
            if (this.selectedRegion) {
                this.selectTailSelectValue(`.card-list__filter__select-region`, this.selectedRegion);
            }
            this.selectedCountry = urlParams.get('map-country') || null;
            if (this.selectedCountry) {
                this.selectTailSelectValue(`.card-list__filter__select-country`, this.selectedCountry);
            }
            this.selectedCategory = urlParams.get('map-category') || null;
            if (this.selectedCategory) {
                this.selectTailSelectValue(`.card-list__filter__select-category`, this.selectedCategory);
            }

            this.$root.addEventListener('imwa-force-re-render', () => {
                const zoom = this.zoom;
                this.zoom += 0.0001;
                setTimeout(() => {
                    this.zoom = zoom;
                }, 1);
            });

            const image = this.$root.querySelector(`.${classes.mapImageNode}`);
            const handleGroupClick = (event) => {
                if (event.target.closest(`.imwa__map__pin--is-group`)) {
                    this.zoomIntoGroup(event.target.closest(`.imwa__map__pin--is-group`));
                }
            }
            image.addEventListener('touchstart', handleGroupClick);
            image.addEventListener('click', handleGroupClick);

            this.calculateGroupPins();
            this.renderGroupPins();

            setTimeout(() => {
                this.calculateGroupPins();
                this.renderGroupPins();
            }, 300);
        },

        selectTailSelectValue(selectSelector, value) {
            this.$root.querySelector(selectSelector).nextSibling.querySelector(`li[data-key="${value}"]`).click();
        },

        calculateGroupPins() {
            const pins = Array.from(this.$root.querySelectorAll('.imwa__map__pin:not(.imwa__map__pin--is-group)'));
            const pinPositions = pins.map(pin => {
                const match = pin.dataset.transform.match(/translate\(([^,]+),([^)]+)\)/);
                return {
                    top: match[1] * 1,
                    left: match[2] * 1,
                    correspondingAccordionItemId: pin.dataset.correspondingAccordionItemId,
                    isPartOfGroup: false
                };
            });

            let threshold = 30 / this.zoom;
            if (window.innerWidth < 768) { // pins need to be bigger on mobile
                threshold = threshold * 1.5;
            }
            this.pinPositions = pinPositions;
            this.groupPins = [];

            pinPositions.forEach((pinPosition, index) => {
                if (pinPosition.isPartOfGroup) {
                    return;
                }

                // is the pin near an existing group?
                this.groupPins.forEach((groupPin, groupIndex) => {
                    if (pinPosition.isPartOfGroup) {
                        return;
                    }
                    const dx = pinPosition.left - groupPin.left;
                    const dy = pinPosition.top - groupPin.top;
                    if (Math.sqrt(dx * dx + dy * dy) <= threshold) {
                        pinPosition.isPartOfGroup = true;
                        this.groupPins[groupIndex].pins.push(pinPosition);
                    }
                });

                if (pinPosition.isPartOfGroup) {
                    return;
                }

                // is the pin near another pin?
                pinPositions.forEach((otherPinPosition, otherIndex) => {
                    if (pinPosition.isPartOfGroup || otherPinPosition.isPartOfGroup || index === otherIndex) {
                        return;
                    }

                    const dx = pinPosition.left - otherPinPosition.left;
                    const dy = pinPosition.top - otherPinPosition.top;
                    if (Math.sqrt(dx * dx + dy * dy) <= threshold) {
                        pinPosition.isPartOfGroup = true;
                        otherPinPosition.isPartOfGroup = true;
                        this.groupPins.push({
                            top: (pinPosition.top + otherPinPosition.top) / 2,
                            left: (pinPosition.left + otherPinPosition.left) / 2,
                            pins: [pinPosition, otherPinPosition],
                        });
                    }
                });
            });

            // now calculate the final group pin center
            this.groupPins.forEach((groupPin) => {
                groupPin.top = groupPin.pins.reduce((acc, pin) => acc + pin.top, 0) / groupPin.pins.length;
                groupPin.left = groupPin.pins.reduce((acc, pin) => acc + pin.left, 0) / groupPin.pins.length;
            });
        },

        renderGroupPins() {
            this.$root.querySelector(`.${classes.mapGroupPinGroup}`).innerHTML = this.groupPins.map((groupPin, index) => {
                let isDisabled = true;
                groupPin.pins.forEach(pin => {
                    const pinEl = this.$root.querySelector(`.imwa__map__pin[data-corresponding-accordion-item-id="${pin.correspondingAccordionItemId}"]`);
                    const countryCodes = JSON.parse(pinEl.dataset.countryCodes);
                    if (this.isPinSelectable(countryCodes, pinEl.dataset.categoryNames)) {
                        isDisabled = false;
                    }
                });
                return `
                    <g
                        class="imwa__map__pin imwa__map__pin--is-group${isDisabled ? ' imwa__map__pin--is-disabled' : ''}"
                        x-transition
                        transform="translate(${groupPin.top},${groupPin.left})"
                        data-transform="translate(${groupPin.top},${groupPin.left})"
                        data-pin-size='{"width": 27.5, "height": 36}'
                        data-index="${index}"
                        x-bind:transform="pinTranslatePosition($el)">
                        <ellipse style="stroke-width:0;" cx="14.7786" cy="12.3268" rx="12.1653" ry="10.745"/>
                        <path
                            fill="currentColor"
                            stroke="white"
                            stroke-width="2"
                            d="m12.0521.3013C4.8702,1.8855.4343,9.173,2.3354,16.2493c.5281,1.5842,1.1618,2.9572,1.9011,4.4359,1.9011,3.4853,4.119,6.7594,6.337,10.0335.7393,1.0562,1.4786,2.1123,2.3236,3.1685.5281.6337,1.0562,1.373,1.5842,2.0067.2112.2112.5281.1056.7393-.1056.3168-.4225.6337-.8449.9505-1.2674.2112-.3168.7393-.9505.9505-1.2674,2.746-3.6966,5.1752-7.3931,7.4987-11.3009.9505-1.5842,1.7955-3.2741,2.4292-5.0696.1056-.4225.3168-.8449.4225-1.2674C29.4787,6.6383,21.135-1.7054,12.0521.3013m2.8701,19.971c-4.2417,0-7.5956-3.4525-7.5956-7.5956,0-4.2417,3.4525-7.5956,7.5956-7.5956s7.5956,3.4525,7.5956,7.5956c.0986,4.143-3.3539,7.5956-7.5956,7.5956"
                        ></path>
                        <text style="font-family: 'Avenir', sans-serif; font-size:15px; font-weight:900;isolation:isolate;" transform="translate(10 18)" fill="currentColor"><tspan x="0" y="0">${groupPin.pins.length}</tspan></text>
                    </g>
                `;
            }).join('');
            this.$root.dispatchEvent(new CustomEvent('imwa-force-re-render', {}));
        },

        onRegionChange(event) {
            this.unsetAccordionItemId();
            this.selectedRegion = event.target.value;
            const countryTail = this.$refs.countrySelect.nextSibling;
            if (this.selectedRegion) {
                this.selectedCountry = null;
                // update the tail-select by clicking the first element
                countryTail.querySelector('.dropdown-option').click();
            }

            // hide the countries that don't belong to the selected region
            const showAllRegions = !this.selectedRegion;
            Array.from(countryTail.querySelectorAll('.dropdown-option')).map((el, index) => {
                const countryName = el.dataset.key;
                el.classList[index === 0 || showAllRegions || this.countryBelongsToRegion(this.selectedRegion, countryName) ? 'remove' : 'add']('is-hidden');
            });

            this.calculateGroupPins();
            this.renderGroupPins();
            this.updateUrlParam('map-region', this.selectedRegion);
        },

        onCountryChange(event) {
            this.selectedCountry = event.target.value;
            this.unsetAccordionItemId();

            this.calculateGroupPins();
            this.renderGroupPins();
            this.updateUrlParam('map-country', this.selectedCountry);
        },

        onCategoryChange(event) {
            this.selectedCategory = event.target.value;
            this.unsetAccordionItemId();

            this.calculateGroupPins();
            this.renderGroupPins();
            this.updateUrlParam('map-category', this.selectedCategory);
        },

        updateUrlParam(name, value) {
            const url = new URL(window.location.href);
            url.searchParams.set(name, value);
            window.history.replaceState({}, '', url);
        },

        countryBelongsToRegion(regionCode, countryCode) {
            const regionCountries = {
                'africa': ['DZ'],
                'asia-and-pacific': ['AU', 'IN', 'NZ'],
                'europe-and-middle-east': ['AT', 'BY', 'BG', 'DE', 'GR', 'IE', 'LB', 'NL', 'NO', 'ES', 'SE', 'AE', 'GB'],
                'latin-america': ['AR', 'BR', 'CL', 'CO', 'DO', 'EC', 'PA', 'PE', 'MX'],
                'north-america': ['US', 'CA'],
            };
            return regionCountries[regionCode].includes(countryCode);
        },

        /**
         *
         * @param countryCodes array of strings
         * @param categoryNames string, comma separated
         * @returns {boolean}
         */
        isPinSelectable(countryCodes, categoryNames) {
            if (this.selectedCountry) {
                let match = false;
                countryCodes.forEach((countryCode) => {
                    if (this.selectedCountry === countryCode) {
                        match = true;
                    }
                });
                if (!match) {
                    return false;
                }
            }
            if (this.selectedRegion) {
                let match = false;
                countryCodes.forEach((countryCode) => {
                    if (this.countryBelongsToRegion(this.selectedRegion, countryCode)) {
                        match = true;
                    }
                });
                if (!match) {
                    return false;
                }
            }
            if (this.selectedCategory && !categoryNames.split(',').includes(this.selectedCategory)) {
                return false;
            }
            return true;
        },

        pinTranslatePosition($el) {
            let zoomFactor = Math.min(2 / this.zoom, 1);
            if (window.innerWidth < 768) { // pins need to be bigger on mobile
                zoomFactor = zoomFactor * 1.5;
            }
            const translate = $el.getAttribute('data-transform');
            const pinSize = JSON.parse($el.getAttribute('data-pin-size'));
            return `${translate} translate(${(pinSize.width / 2) * (1-zoomFactor)}, ${pinSize.height * (1-zoomFactor)}) scale(${zoomFactor})`;
        },

        toggleAccordionItem(activeAccordionItemId) {
            if (this.activeAccordionItemId && this.activeAccordionItemId === activeAccordionItemId) {
                this.unsetAccordionItemId();
            } else {
                this.activeAccordionItemId = activeAccordionItemId;

                // scroll on mobile
                if (window.innerWidth < 768) {
                    setTimeout(() => {
                        this.scrollToElement(document.getElementById(this.activeAccordionItemId));
                    }, 350);
                }
            }
        },

        openAndScrollToAccordionItem(activeAccordionItemId) {
            this.activeAccordionItemId = activeAccordionItemId;

            setTimeout(() => {
                this.scrollToElement(document.getElementById(this.activeAccordionItemId));
            }, 350);
        },

        scrollToElement(element) {
            const header = document.querySelector('.header__inner');
            const headerHeight = header ? header.getBoundingClientRect().height : 0;
            window.scrollTo({
                behavior: 'smooth',
                left: 0,
                top: element.offsetTop + element.closest('.imwa__accordion').offsetTop - headerHeight
            });
        },

        unsetAccordionItemId() {
            this.activeAccordionItemId = null;
        },

        animateMove(zoomAndPanCallback) {
            this.$root.classList.add(classes.mapAnimated);
            zoomAndPanCallback();
            this.zoom = this.map.getZoom();
            this.calculateGroupPins();
            this.renderGroupPins();
            setTimeout(() => {
                this.$root.classList.remove(classes.mapAnimated);
            }, 300);
        },

        zoomIn() {
            this.animateMove(() => {
                this.map.zoomIn();
            });
        },

        zoomOut() {
            this.animateMove(() => {
                this.map.zoomOut();
            });
        },

        zoomIntoGroup(groupPin) {
            const groupIndex = groupPin.dataset.index;
            const group = this.groupPins[groupIndex];
            if (!group || !group.pins.length) {
                return;
            }
            let minDistance = Infinity;
            if (group.pins.length > 1) {
                group.pins.forEach((pinA, i) => {
                    for (let j = i + 1; j < group.pins.length; j++) {
                        const pinB = group.pins[j];
                        const dx = pinA.left - pinB.left;
                        const dy = pinA.top - pinB.top;
                        const distance = Math.sqrt(dx * dx + dy * dy);
                        if (distance < minDistance) {
                            minDistance = distance;
                        }
                    }
                });
            }

            const isMobile = window.innerWidth < 768;
            const requiredZoom =
                minDistance !== Infinity
                    ? (30 / minDistance) * 1.1 * (isMobile ? 1.5 : 1)
                    : this.map.getZoom() * 1.5;

            this.animateMove(() => {
                const el = groupPin.closest('.imwa__map__pin');
                let bbox = el.getBBox();
                // we are using transform on the pin, so that must be included
                const transform = this.getTranslateXYFromTransformAttribute(el);
                bbox.x = bbox.x + transform.x;
                bbox.y = bbox.y + transform.y;
                this.focusOn(bbox, requiredZoom);
            });
        },

        focusOn(bbox, zoom) {
            // taken from https://github.com/bumbu/svg-pan-zoom/issues/381
            // just the zoom doesn't work properly

            // pan so the el is at the center
            const { width, height, realZoom } = this.map.getSizes();
            this.map.pan({
                x: -realZoom * (bbox.x - width / (realZoom * 2) + bbox.width / 2),
                y: -realZoom * (bbox.y - height / (realZoom * 2) + bbox.height / 2),
            });

            // we want to zoom in to see just around the el -
            //const relativeZoom = this.map.getZoom();
            //const desiredWidth = 50 * Math.sqrt(bbox.width / 25) * 11 * realZoom;
            //this.map.zoom((relativeZoom * width) / desiredWidth);
            this.map.zoom(zoom);
        },

        getTranslateXYFromTransformAttribute(el) {
            const t = el.getAttribute('transform');
            const [, x, y] = t.match(/translate\(\s*([+-]?\d*\.?\d+)\s*,\s*([+-]?\d*\.?\d+)\s*\)/);
            return { x: x*1, y: y*1 };
        }
    }));
});
